// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.themebrowser-body {
    background-color: var(--list-bg-color);
    padding: 0.25em;
}

div.themebrowser-theme-container {
    position: relative;
}

div.themebrowser-theme-container:not(:last-child) {
    margin-bottom: 0.25em;
}

div.themebrowser-theme {
    background-color: var(--button-bg-color);
    color: var(--button-text-color);
    border-radius: 0.5em;
    font-weight: bold;
    padding: 0 0.5em;
    display: flex;
    align-items: center;
    cursor: pointer;
    height: 2.5em;
}

div.themebrowser-theme:hover {
    background-color: var(--button-bg-color-hover);
    color: var(--button-text-color-hover);
}

div.themebrowser-theme > span:first-child {
    flex: 1 1 auto;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

div.themebrowser-tree {
    margin-right: 0.25em;
}

div.themebrowser-tree-entry-container {
    margin: .25em 0 .25em 1em;
}

div.themebrowser-tree-entry {
    border-radius: 1em;
    height: 2em;
    border: 2px solid var(--border-color);
    color: var(--border-color);
    padding: 0 0.25em;
    display: flex;
    align-items: center;
}

div.themebrowser-tree-entry-visible {
    background-color: var(--border-color);
    color: white;
}

div.themebrowser-tree-entry-inactive {
    font-style: italic;
}

div.themebrowser-tree-entry-detailsvisible {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

.themebrowser-tree-entry-plus {
    transition: transform 0.25s;
}

.themebrowser-tree-entry-plus-remove {
    transform: rotate(45deg);
}

span.themebrowser-tree-entry-title {
    padding-left: 0.5em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1 1 auto;
}

div.themebrowser-tree-entry-transparent > span.themebrowser-tree-entry-title {
    cursor: ew-resize;
}

span.themebrowser-tree-entry-opacity {
    cursor: ew-resize;
    display: none;
}

span.themebrowser-tree-entry-drag {
    cursor: grab;
    padding: 0 0.5em;
}

div.themebrowser-tree-entry:focus > span.themebrowser-tree-entry-opacity,
div.themebrowser-tree-entry:hover > span.themebrowser-tree-entry-opacity {
    display: initial;
}

div.themebrowser-tree-entry-details {
    border: 2px solid var(--border-color);
    border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em;
    padding: 0.25em;
}

div.themebrowser-resize-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99999;
    cursor: ew-resize;
}

div.themebrowser-theme-trashdrop {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2.5em;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--list-bg-color);
    border: 2px solid var(--border-color);
    color: red;
    opacity: 0.85;
}

div.themebrowser-theme-trashdrop-over {
    opacity: 1;
    border-color: red;
}

`, "",{"version":3,"sources":["webpack://./plugins/ThemeBrowser.css"],"names":[],"mappings":"AAAA;IACI,sCAAsC;IACtC,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wCAAwC;IACxC,+BAA+B;IAC/B,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,qCAAqC;IACrC,0BAA0B;IAC1B,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,8BAA8B;IAC9B,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sCAAsC;IACtC,qCAAqC;IACrC,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,iBAAiB;AACrB","sourcesContent":["div.themebrowser-body {\n    background-color: var(--list-bg-color);\n    padding: 0.25em;\n}\n\ndiv.themebrowser-theme-container {\n    position: relative;\n}\n\ndiv.themebrowser-theme-container:not(:last-child) {\n    margin-bottom: 0.25em;\n}\n\ndiv.themebrowser-theme {\n    background-color: var(--button-bg-color);\n    color: var(--button-text-color);\n    border-radius: 0.5em;\n    font-weight: bold;\n    padding: 0 0.5em;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    height: 2.5em;\n}\n\ndiv.themebrowser-theme:hover {\n    background-color: var(--button-bg-color-hover);\n    color: var(--button-text-color-hover);\n}\n\ndiv.themebrowser-theme > span:first-child {\n    flex: 1 1 auto;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\ndiv.themebrowser-tree {\n    margin-right: 0.25em;\n}\n\ndiv.themebrowser-tree-entry-container {\n    margin: .25em 0 .25em 1em;\n}\n\ndiv.themebrowser-tree-entry {\n    border-radius: 1em;\n    height: 2em;\n    border: 2px solid var(--border-color);\n    color: var(--border-color);\n    padding: 0 0.25em;\n    display: flex;\n    align-items: center;\n}\n\ndiv.themebrowser-tree-entry-visible {\n    background-color: var(--border-color);\n    color: white;\n}\n\ndiv.themebrowser-tree-entry-inactive {\n    font-style: italic;\n}\n\ndiv.themebrowser-tree-entry-detailsvisible {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n}\n\n.themebrowser-tree-entry-plus {\n    transition: transform 0.25s;\n}\n\n.themebrowser-tree-entry-plus-remove {\n    transform: rotate(45deg);\n}\n\nspan.themebrowser-tree-entry-title {\n    padding-left: 0.5em;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    flex: 1 1 auto;\n}\n\ndiv.themebrowser-tree-entry-transparent > span.themebrowser-tree-entry-title {\n    cursor: ew-resize;\n}\n\nspan.themebrowser-tree-entry-opacity {\n    cursor: ew-resize;\n    display: none;\n}\n\nspan.themebrowser-tree-entry-drag {\n    cursor: grab;\n    padding: 0 0.5em;\n}\n\ndiv.themebrowser-tree-entry:focus > span.themebrowser-tree-entry-opacity,\ndiv.themebrowser-tree-entry:hover > span.themebrowser-tree-entry-opacity {\n    display: initial;\n}\n\ndiv.themebrowser-tree-entry-details {\n    border: 2px solid var(--border-color);\n    border-bottom-left-radius: 1em;\n    border-bottom-right-radius: 1em;\n    padding: 0.25em;\n}\n\ndiv.themebrowser-resize-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 99999;\n    cursor: ew-resize;\n}\n\ndiv.themebrowser-theme-trashdrop {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 2.5em;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: var(--list-bg-color);\n    border: 2px solid var(--border-color);\n    color: red;\n    opacity: 0.85;\n}\n\ndiv.themebrowser-theme-trashdrop-over {\n    opacity: 1;\n    border-color: red;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
